import React, { useEffect } from "react";
import "../style/page/Publications.css";
import PublicationsTable from "../component/PublicationsTable";
import { usePublicationsContent } from "../hooks/usePublicationsContent";

function Publications() {
  const content = usePublicationsContent();

  // Update page title when content changes
  useEffect(() => {
    if (content.metaTitle) {
      document.title = content.metaTitle;
    }
  }, [content.metaTitle]);

  return (
    <main className="main-content publications-page">
      <h4 className="page-title" data-translate="publications.title">
        {content.title}
      </h4>

      <p className="description" data-translate="publications.description">
        {content.description}
      </p>

      {/* BẢNG CÔNG BỐ KHOA HỌC */}
      <PublicationsTable publications={content.publications} headerTexts={content.headerTexts} />
      {/* HẾT BẢNG CÔNG BỐ */}
    </main>
  );
}

export default Publications;
